// src/pages/ErrorPage.jsx
import React from 'react';
import { Container, Row, Col, Button, Image, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
// import errorImage from '../assets/error-illustration.png'; // rasmni joylashtirgan bo‘lsang

const ErrorPage = () => {
    const navigate = useNavigate();

    return (
        <Container className="vh-100 d-flex align-items-center justify-content-center">
            <Row className="text-center">
                <Col>
                    {/* Agar rasm qo‘shgan bo‘lsang */}
                    {/* <Image src={errorImage} alt="Error" fluid style={{ maxWidth: '400px' }} className="mb-4" /> */}

                    <h1 className="display-4 text-danger fw-bold">Oops! Xatolik yuz berdi</h1>
                    <p className="lead text-muted mb-4">
                        Tizimda kutilmagan xatolik yuz berdi. Iltimos, keyinroq qayta urinib ko‘ring.
                    </p>

                    <Alert variant="light" className="w-75 mx-auto shadow-sm">
                        <p className="mb-1">
                            <strong>Mumkin bo‘lgan sabablar:</strong>
                        </p>
                        <ul className="text-start mb-0">
                            <li>Server ishlamayapti</li>
                            <li>Tarmoqqa ulanmagan bo‘lishingiz mumkin</li>
                            <li>Manzilda xatolik bor</li>
                        </ul>
                    </Alert>

                    <Button variant="primary" className="mt-4" onClick={() => navigate('/')}>
                        🔙 Bosh sahifaga qaytish
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default ErrorPage;
